import { useNavigate } from "react-router-dom";
import { useTranslation } from "@hooks/useTranslation";

const Component = ({ ped }) => {

  const navigate = useNavigate();
  const {translate} = useTranslation();

  return (
    <div className="AgregadoItem">
      <div>
        <div
          className="AgregadoItemImg"
          style={{ backgroundImage: `url(${ped.desktop_image})` }}
        ></div>
        <div>
          <p>{ped.name}</p>
          <em>{translate('product.quantity')}: {ped.quantity} </em>
          <em> {translate('product.size')}: {ped.size} </em>
          {ped.color_name && (
            <em> {translate('product.color')}: {ped.color_name} </em>
          )}
          {/* <em>
              <b>Fecha de la compra: </b>
              <span>02 Noviembre 2023</span>
            </em> */}

          <em>{ped.description}</em>
          <div className="links">
            <a onClick={() => navigate("/detalles-producto/" + ped.uri)}
              style={{ cursor: "pointer" }}
            >{translate('view.orders.buynew')}</a>
            <a onClick={() => { navigate("/cambios-y-devoluciones") }} style={{ cursor: "pointer" }}>{translate('view.orders.view_item')}</a>
          </div>
        </div>
      </div>
      <div>
        ${ped.subtotal}

      </div>
    </div>
  );
};

export default Component;
